// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const collectionsClient = createTypedClient();
export const createCollectionsClient = (config) => createTypedClient(config);
